interface PendingRequestBody {
  params?: {
    lbid?: string;
    lbeid?: string;
    partid?: string;
    meid?: string;
    list?: Array<{
      lbeid?: string | null;
      partid?: string | null;
      meid?: string | null;
    }>;
  };
  meid?: string;
  partid?: string;
  lbeid?: string;
}

const parseLbidFromEntryId = (entryId: string) => {
  const lbidPart = entryId.split("&&").find(part => part.startsWith("lbid="));
  return lbidPart ? lbidPart.slice(5) : undefined;
};

const resolveIdType = (
  entryId: string,
  body: PendingRequestBody,
): "lbeid" | "partid" | "meid" | null => {
  if (body.params?.meid || body.meid || entryId.includes("meid=")) {
    return "meid";
  }
  if (body.params?.partid || body.partid) {
    return "partid";
  }
  if (body.params?.lbeid || body.lbeid || entryId) {
    return "lbeid";
  }
  return null;
};

const buildLogbookRoute = (
  lbid: string,
  idType: "lbeid" | "partid" | "meid",
  entryId: string,
) => `/logbook/${lbid}/${idType}/${entryId}`;

export const getPendingRequestRoute = (
  pending: { req: string; data: string },
): string | null => {
  let body: PendingRequestBody;
  try {
    body = JSON.parse(pending.data);
  } catch {
    return null;
  }

  const [request, entryId] = pending.req.split("__");
  if (!request || !entryId) {
    return null;
  }

  if (request === "save-entry" || request === "withdraw-entry") {
    const lbid = body.params?.lbid ?? parseLbidFromEntryId(entryId);
    const idType = resolveIdType(entryId, body);
    if (!lbid || !idType) {
      return null;
    }
    return buildLogbookRoute(lbid, idType, entryId);
  }

  if (request === "upload-file") {
    const resolvedEntryId = body.meid ?? body.partid ?? body.lbeid ?? entryId;
    const lbid = body.params?.lbid ?? parseLbidFromEntryId(resolvedEntryId);
    const idType = resolveIdType(resolvedEntryId, body);
    if (!lbid || !idType || !resolvedEntryId) {
      return null;
    }
    return buildLogbookRoute(lbid, idType, resolvedEntryId);
  }

  if (request === "verify-entry") {
    const item = body.params?.list?.[0];
    if (!item) {
      return null;
    }
    if (item.meid) {
      return `/summary/verify-entries/meid/${item.meid}`;
    }
    if (item.partid) {
      return `/summary/verify-entries/partid/${item.partid}`;
    }
    if (item.lbeid) {
      return `/summary/verify-entries/lbeid/${item.lbeid}`;
    }
  }

  return null;
};
